import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums'
import LoadingState from '../components/LoadingState'

const AssetPage = lazy(() => import('../pages/pages/Asset'))

export default [
  {
    path: '/assets/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <AssetPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
